import fuzzysort from "fuzzysort";

require('./../bootstrap');
require('datatables');
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueFuse from 'vue-fuse'
import Vuex from 'vuex'
import axios from 'axios'
// $(document).ready(function () {
//
//     table = $('table.dt').DataTable({
//         "bStateSave": true,
//         language: {
//             decimal: "",
//             emptyTable: "Er zijn momenteel geen items om weer te geven",
//             info: "_START_ - _END_ van _TOTAL_",
//             infoEmpty: "Toont 0 tot 0 van 0 items",
//             infoFiltered: "(gefilterd uit _MAX_ resultaten)",
//             infoPostFix: "",
//             thousands: ".",
//             lengthMenu: "Toon _MENU_ items",
//             loadingRecords: "Laden...",
//             processing: "Verwerken...",
//             search: "Zoeken:",
//             zeroRecords: "Geen items gevonden.",
//             paginate: {
//                 first: "<<",
//                 last: ">>",
//                 next: ">",
//                 previous: "<"
//             },
//             aria: {
//                 "sortAscending": ": Sorteer aflopend",
//                 "sortDescending": ": Sorteer oplopend"
//             }
//         }
//     });
//     $.fn.dataTable.ext.search.push(
//         function( settings, data, dataIndex ) {
//             var searchval = $('input.fuzzy').val();
//             if (searchval == '') {
//                 return true;
//             }
//             var results = fuzzysort.go(searchval, data)
//             console.log(results.length);
//             if ( results.length > 0  )
//             {
//                 console.log('show row');
//                 return true;
//             }
//             console.log('hide row')
//             return false;
//         }
//     );
//
//     $('<input type="text" class="fuzzy">').appendTo('.dataTables_filter');
//     $('.dataTables_filter input[search]').hide()
//     $('.fuzzy').keyup(function(e) {
//         table.draw();
//     })
//
//
//
// })

Vue.use(VueRouter)
Vue.use(VueFuse)
Vue.use(Vuex)
Vue.prototype.$http = axios
import App from './views/App'
//import Hello from './views/Hello'
import Home from './views/Home'
import Navbar from './components/navbar';
import storeData from "./store/index"
const store = new Vuex.Store(
    storeData
)


Vue.mixin(require('./mixins/paths'));

Vue.component('navbar', Navbar);
const router = new VueRouter({
    mode: 'history',
    base: '/bestelplatform',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
    ],
});

const app = new Vue({
    el: '#app',
    components: { App, Navbar },
    router,
    store,
    axios,
});

